import { render } from "./bounding-box-view.vue?vue&type=template&id=b1077114&scoped=true"
import script from "./bounding-box-view.vue?vue&type=script&lang=js"
export * from "./bounding-box-view.vue?vue&type=script&lang=js"

import "./bounding-box-view.vue?vue&type=style&index=0&id=b1077114&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1077114"]])

export default __exports__